module.exports = __webpack_public_path__ + "img/clock-circle-svgrepo-com.7d8b27f5.svg";